import { useState } from "react";
import styles from "./AddUserModal.module.css";
import Button from "../components/Button";
import { validateForm } from "../helpers/helperFunctions";
import { flashAlert, makeInvalid } from "../global_js";

function AddUserModal({ restLocations, getUsers }) {
  const [isOpen, setIsOpen] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userLogin"));

  const initialUser = {
    firstname: "",
    lastname: "",
    email: "",
    locationId: "",
    password: Math.random().toString(36).substr(2, 9),
  };

  const [newUser, setNewUser] = useState(initialUser);

  const saveNewUser = async () => {
    if (!validateForm(document.getElementById("userForm"))) {
      return;
    }

    const formBody = new URLSearchParams({
      firstname: newUser.firstname,
      lastname: newUser.lastname,
      email: newUser.email,
      locationId: newUser.locationId,
      password: newUser.password,
    });

    const res = fetch("/api/users", {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formBody,
    })
      .then((res) => {
        res.json();
      })
      .then((data) => {
        console.log(data);
        if (data.code) {
          flashAlert("Error saving new uers" + data.code, "error");
        } else {
          getUsers();
          closeModal();
        }
      });
  };

  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setIsOpen((x) => !x);
    setNewUser(initialUser);
  };

  return (
    <>
      <Button type="pOutline" onClick={openModal}>
        Create New User
      </Button>
      {isOpen && (
        <div className={styles.modalBackdrop}>
          <div className={`${styles.modalContent}`}>
            <h3 className={styles.modalHeader}>Add New User</h3>
            <div id="userForm" className={styles.modalBody}>
              <div className={styles.inputGroup}>
                <label htmlFor="">First name</label>
                <input
                  type="text"
                  value={newUser.firstname}
                  onChange={(e) => {
                    setNewUser({ ...newUser, firstname: e.target.value });
                  }}
                  onInvalid={makeInvalid}
                  required
                />
                <div className="invalid-feedback" style={{ flexBasis: "100%", textAlign: "right" }}>
                  First name required
                </div>
              </div>
              <div className={styles.inputGroup}>
                <label htmlFor="">Last name</label>
                <input
                  type="text"
                  value={newUser.lastname}
                  onChange={(e) => {
                    setNewUser({ ...newUser, lastname: e.target.value });
                  }}
                  onInvalid={makeInvalid}
                  required
                />
                <div className="invalid-feedback" style={{ flexBasis: "100%", textAlign: "right" }}>
                  Last name required
                </div>
              </div>
              <div className={styles.inputGroup}>
                <label htmlFor="">Email</label>
                <input
                  type="text"
                  value={newUser.email}
                  onChange={(e) => {
                    setNewUser({ ...newUser, email: e.target.value });
                  }}
                  onInvalid={makeInvalid}
                  required
                />
                <div className="invalid-feedback" style={{ flexBasis: "100%", textAlign: "right" }}>
                  Email required
                </div>
              </div>
              <div className={styles.inputGroup}>
                <label htmlFor="">Location</label>
                <select
                  className={styles.userSelect}
                  value={newUser.locationId}
                  name="Location"
                  defaultValue={newUser.locationId}
                  onInvalid={makeInvalid}
                  onChange={(e) => {
                    setNewUser({ ...newUser, locationId: e.target.value });
                  }}
                  required
                  min="0"
                >
                  <option value="">--Choose location--</option>
                  {restLocations.length > 1 && <option value={0}>All</option>}
                  {restLocations.map((rest) => {
                    return <option value={rest.idLocation}>{rest.Description}</option>;
                  })}
                </select>
                <div className="invalid-feedback" style={{ flexBasis: "100%", textAlign: "right" }}>
                  Location required
                </div>
              </div>
              <div className={styles.buttonGroup}>
                <Button type="primary" onClick={() => saveNewUser()}>
                  Save
                </Button>
                <Button type="pOutline" onClick={() => closeModal()}>
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddUserModal;
